<template>
  <div :class="{ show: show }" class="mobile-filter-popup">
    <inline-svg class="clear-icon" :src="require('@/assets/img/icons/clear.svg')" @click="hideFilters()"></inline-svg>
    <h2 class="popup-title">Filters</h2>
    <div class="mobile-filter-scroll-section">
      <filter-badges class="mobile-filter-badges" />
      <filter-panel
        :total-count="totalCount"
        is-mobile
        class="mobile-filter-panel"
        :filter-panel-config="filterPanelConfig"
      />
    </div>
    <div class="view-results">
      <bulletin-button variant="primary" full-width @click="hideFilters()">View Results</bulletin-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/base/_vars.scss";

.mobile-filter-popup {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  display: none;
  background: white;
  z-index: 3;
  &.show {
    display: block;
  }

  .mobile-filter-badges {
    padding-left: 16px;
    padding-right: 16px;
  }

  .mobile-filter-panel {
    padding: 0 16px;
    margin-top: 8px;
  }

  .mobile-filter-scroll-section {
    max-height: calc(100vh - 182px);
    overflow: auto;
  }

  .view-results {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
    border-top: 1px solid black;
    background: white;
    z-index: 2;
  }

  .popup-title {
    margin-top: 48px;
    margin-left: 16px;
    margin-bottom: 16px;
    font-size: 32px;
  }

  .clear-icon {
    position: fixed;
    top: 16px;
    right: 16px;
    width: 40px;
    height: 40px;

    transition: opacity $defaultTransitionTime $defaultTransitionType;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
}
</style>
<script>
import InlineSvg from "vue-inline-svg";
import { bodyScrollHelper } from "../../mixin/bodyScrollHelper";

export default {
  components: {
    InlineSvg,
  },
  mixins: [bodyScrollHelper],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    hideFilters: {
      type: Function,
      default: () => {},
    },
    filterPanelConfig: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
